import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  ESTADOSFINANCIEROS_REPORTE,
  ESTADOSFINANCIEROS_BALANCEGENERAL,
  ESTADOSFINANCIEROS_BALANCESUNAT_PLEANUAL,
  ESTADOSFINANCIEROS_CIERRECLASE679
} from 'constants/codigosTransacciones'

import ReportesPage from './reportes'
import BalanceGeneralPage from './balanceGeneral'
import * as BalanceSunatPages from './balanceSunat'
import CierreClase679Page from './cierreClase679'

export default function ContabilidadCostosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ESTADOSFINANCIEROS_CIERRECLASE679}`} component={CierreClase679Page} />
        <Route path={`/${ESTADOSFINANCIEROS_REPORTE}`} component={ReportesPage} />
        <Route path={`/${ESTADOSFINANCIEROS_BALANCEGENERAL}`} component={BalanceGeneralPage} />
        <Route path={`/${ESTADOSFINANCIEROS_BALANCESUNAT_PLEANUAL}`} component={BalanceSunatPages.PleAnualPage} />
      </Switch>
    </Suspense>
  )
}
